import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../../../../../context/AuthContext';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import GeneralRequestHelper from '../../../../../../../Helpers/GeneralRequestHelper';
import SubmitButton from '../UI/SubmitButton';
import InfoInput from '../UI/InfoInput';
import CorrectAnswer from '../UI/CorrectAnswer';
import QuestionTextInput from '../UI/QuestionTextInput';
import AddContentQuestion from '../UI/AddContentQuestion';
import Tag from '../UI/Tag';
import TitleArea from '../UI/TitleArea';
import AnswerForm from '../UI/AnswerForm';
import axios from "axios";
import { API_BASE_URL } from "../../../../../../../Helpers/apiConfig";

const Match = (props) => {
    const { user } = useAuth();
    const params = useParams()
    const navigate = useNavigate();
    const [msg, setMsg] = useState([]);
    const [imagePath, setImagePath] = useState(null);
    const [videoPath, setVideoPath] = useState(null);
    const [soundPath, setSoundPath] = useState(null);
    const [data, setData] = useState([]);
    const [splitMode, setSplitMode] = useState("auto");

    const tokenize = (rawInput, mode) => {
        const s = (rawInput ?? "").trim();
        if (!s) return [];
        if (mode === "mixed") {
            const bySpace = s.split(/\s+/).filter(Boolean);
            return bySpace.flatMap(t => t.split(/[-_]+/).filter(Boolean));
        }
        if (s.includes(" ")) return s.split(/\s+/).filter(Boolean);
        return s.split("");
    };
    const handletype3 = async (e) => {
        e.preventDefault();
        var answer = document.getElementById("correctAnswer").value;
        var detailAnswer = [];

        const rawInput = document.getElementById("correctAnswer").value;
        let parsedArray = tokenize(rawInput, splitMode);
        // Shuffle
        for (let i = parsedArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [parsedArray[i], parsedArray[j]] = [parsedArray[j], parsedArray[i]];
        }

        for (let i = 0; i < parsedArray.length; i++) {
            let answerItem = {
                id: i,
                service: parsedArray[i]
            };
            detailAnswer.push(answerItem);
        }

        var splittedanswerjs = JSON.stringify(detailAnswer);




        var question;
        let questiontext = document.getElementById("questionText").value;
        if (imagePath) {
            question = {
                type: "image",
                url: imagePath,
                text: questiontext,
                mode: splitMode
            }
        }
        else if (soundPath) {
            question = {
                type: "sound",
                url: soundPath,
                text: questiontext,
                mode: splitMode
            }
        }
        else if (videoPath) {
            question = {
                type: "video",
                url: videoPath,
                text: questiontext,
                mode: splitMode
            }
        }
        else {
            question = {
                type: "text",
                url: "",
                text: questiontext,
                mode: splitMode
            }
        }
        var stringquestion = JSON.stringify(question)

        var info = document.getElementById("infoBoxText").value;



        try {
            var questionn = {
                isDeleted: data.isDeleted,
                tagId: document.getElementById("tagId").value,
                sortId: data.sortId,
                contentType: "match",
                subjectId: params["subject"],
                contentStr: stringquestion,
                detail: splittedanswerjs,
                notfyText: info,
                answer: answer,
                id: params['sort']
            }
            await GeneralRequestHelper("/api/admin/ContentManager/Update", "post", questionn, user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Soru listesi sayfasına Dön`,
                            timer: 5000,
                        }).then(() => {
                            navigate("/admin/questionlist");
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message)
            setMsg(err.message);
        }
    }
    const getQuestion = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/ContentManager/GetById`;
            await axios({
                method: 'GET',
                url: url,
                headers: headerss,
                params: {
                    id: params["sort"]
                }
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setData(res.data['data'])
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err);
        }
    }
    useEffect(() => {
        getQuestion();
    });

    return (
        <div>
            <TitleArea msg={msg} text={"Eşleştirme Oluşturma Sayfası"} />
            <Tag />
            <AddContentQuestion setMsg={setMsg} setImagePath={setImagePath} setVideoPath={setVideoPath} setSoundPath={setSoundPath} />
            <form onSubmit={handletype3} >
                <QuestionTextInput />
                <CorrectAnswer text="Lütfen büyük harfler ile yazınız. ÖRN cevap:'LION IS THE KING', kelime de ise-> örn kelime:'L I O N' harfler arası 1 boşluk (son harften sonra boşluk yok.) " />
                <div style={{ margin: "12px 0" }}>
                    <label style={{ display: "block", marginBottom: 6 }}>Parçalama türü</label>
                    <select className="form-select" value={splitMode} onChange={(e) => setSplitMode(e.target.value)}>
                        <option value="auto">Otomatik (Eski Sistemdeki gibi)</option>
                        <option value="mixed">Karışık (Harf Harf - volume up gibi)</option>
                    </select>
                </div>
                <InfoInput />
                <SubmitButton />
            </form>
            <hr />
            <hr />
        </div>
    );
};

export default Match;